/**
 * Email links carry their one-time token in the URL fragment (#token=…), so
 * it never reaches server logs or Referer headers. Read it once and remove
 * it from the address bar.
 */
export function takeHashToken(): string | null {
  const match = /(?:^#|&)token=([A-Za-z0-9_-]{16,256})/.exec(window.location.hash);
  if (!match?.[1]) return null;
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
  return match[1];
}

const PENDING_INVITE = 'dbrain.pendingInvite';

export function rememberInviteToken(token: string): void {
  try {
    sessionStorage.setItem(PENDING_INVITE, token);
  } catch {
    // ignore
  }
}

export function pendingInviteToken(): string | null {
  try {
    return sessionStorage.getItem(PENDING_INVITE);
  } catch {
    return null;
  }
}

export function clearInviteToken(): void {
  try {
    sessionStorage.removeItem(PENDING_INVITE);
  } catch {
    // ignore
  }
}
